// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__ycbtL","visible":"tooltip_visible__AOdMI","arrow":"tooltip_arrow__zREmX"};